import React, { Component } from "react";
import {Modal, Row, Button} from "antd";
import CheckIcon from "../../assets/icons/check-icon.svg";
import "./PendingPaymentModal.css";
import {injectIntl} from "react-intl";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";

export class PendingPaymentModal extends Component {

    render(){
        const {
            showPendingPaymentModal,
            handleHidePendingPaymentModal,
            title,
            newColor,
            closable = true,
            paymentUrl = "",
            closeLabel = "",
            rol = ""
        } = this.props;

        return (
            <React.Fragment>
                <Modal
                    visible = {showPendingPaymentModal}
                    onCancel={handleHidePendingPaymentModal}
                    closable={closable}
                    width={540}
                    footer={null}
                    centered
                >
                    <div className="p-p-container">
                        <img className="p-p-img" src={CheckIcon} alt="check" onClick={handleHidePendingPaymentModal}/>
                        <p className="p-p-p">
                            {title}
                        </p>
                        <Row type={'flex'} justify={'center'}>
                            <Button 
                                size={'large'} 
                                style={{ marginRight: 20, borderColor: newColor, color: newColor}}
                                onClick={handleHidePendingPaymentModal}
                            >
                                {closeLabel}
                            </Button>
                            {rol === "admin" && <Button 
                                size={'large'} 
                                type={'primary'} 
                                style={{ 
                                    backgroundColor: newColor, 
                                    borderColor: newColor
                                }}
                                onClick={()=> {
                                    if(paymentUrl.length === 0) return;
                                    window.open(paymentUrl, "_self", "noreferrer");
                                }}
                            >
                                Ir a pagar
                            </Button>}
                        </Row>
                    </div>
                </Modal>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
      newColor: state.authUser.user && state.authUser.user.color ? state.authUser.user.color : '#2E97CF',
    }
}

const mapDispatchToProps = {

}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(PendingPaymentModal)));
